// Shared mobile bottom nav bar — matches the Flutter floating_bottom_nav.
import iconJobs         from "../../assets/jobs.png"
import iconApplications from "../../assets/applications.png"
import iconWild         from "../../assets/wild.png"
import iconInbox        from "../../assets/Inbox.png"
import iconProfile      from "../../assets/profile.png"

const FF = '"Plus Jakarta Sans", "Inter", -apple-system, sans-serif'
const INK         = "#0F172A"
const INK_SUBTLE  = "#94A3B8"
const LIGHT_BG    = "#FFFFFF"
const BORDER_SOFT = "#E6E5DF"

export const NAV_ITEMS = [
  { id: "profile",      label: "Profile",      iconSrc: iconProfile },
  { id: "wild",         label: "Wild",         iconSrc: iconWild },
  { id: "console",      label: "Jobs",         iconSrc: iconJobs },
  { id: "applications", label: "Applications", iconSrc: iconApplications },
  { id: "inbox",        label: "Inbox",        iconSrc: iconInbox },
]

export function NavImgIcon({ src, size = 24 }) {
  return (
    <span style={{
      display: "inline-block",
      width: size, height: size,
      background: "currentColor",
      WebkitMaskImage: `url(${src})`,
      maskImage: `url(${src})`,
      WebkitMaskSize: "contain",
      maskSize: "contain",
      WebkitMaskRepeat: "no-repeat",
      maskRepeat: "no-repeat",
      WebkitMaskPosition: "center",
      maskPosition: "center",
      flexShrink: 0,
    }} />
  )
}

export default function MobileBottomNav({ activeTab, onTabChange, pendingApplications = 0 }) {
  return (
    <nav style={{
      position: "fixed",
      left: 0, right: 0, bottom: 0,
      zIndex: 300,
      background: LIGHT_BG,
      borderTop: `1px solid ${BORDER_SOFT}`,
      padding: "10px 4px calc(6px + env(safe-area-inset-bottom))",
      display: "flex",
      fontFamily: FF,
    }}>
      {NAV_ITEMS.map((item) => {
        const selected = activeTab === item.id
        const showBadge = item.id === "applications" && pendingApplications > 0
        return (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 4,
              background: "transparent",
              border: "none",
              padding: "4px 0",
              cursor: "pointer",
              color: selected ? INK : INK_SUBTLE,
              fontFamily: FF,
            }}
          >
            <div style={{ position: "relative", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <NavImgIcon src={item.iconSrc} size={26} />
              {showBadge && (
                <span style={{
                  position: "absolute",
                  top: -2, right: -8,
                  minWidth: 18, height: 18,
                  padding: "0 5px",
                  background: "#F97316",
                  borderRadius: 999,
                  color: "#fff",
                  fontSize: 10,
                  fontWeight: 700,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                  {pendingApplications > 99 ? "99+" : pendingApplications}
                </span>
              )}
            </div>
            <span style={{
              fontSize: 11,
              fontWeight: selected ? 700 : 500,
              color: selected ? INK : INK_SUBTLE,
            }}>{item.label}</span>
          </button>
        )
      })}
    </nav>
  )
}
